<template>
	<div class="region-selector">


		<template v-if="hasUserRegions && $root.userRegions.length > 0">

			<div class="region-selector__group">
				<div class="region-selector__group-header">
					<div class="grid grid--g16 grid--auto grid--nowrap grid--middle grid--spread-between">
						<div class="grid__item">
							<div class="region-selector__group-title">Your regions</div>
						</div>
						<div class="grid__item">
						</div>
					</div>
				</div>

				<div class="region-selector__group-body">
					<div class="grid grid--b0 grid--v-spread-items">
						<div class=" grid__item one-half" v-if="!$store.state.app.hiddenRegions.includes(option.key)" v-for="(option, j) in $root.userRegions" :key="option.key">
							<div class="region-selector__group-item">
								<CheckboxField v-if="isMultiSelect" :options="[option]" :value="value" @input="$emit('input', $event)"></CheckboxField>
								<RadioField v-else :options="[option]" :value="value" @input="$emit('input', $event)"></RadioField>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr />

		</template>


		<template v-if="hasSelectedSummary">

			<div class="region-selector__group">
				<div class="region-selector__group-header">
					<div class="grid grid--g16 grid--auto grid--nowrap grid--middle">
						<div class="grid__item">
							<div class="region-selector__group-title">Selected Regions</div>
						</div>
						<div v-if="selectedRegions && selectedRegions.length > 0" class="grid__item">
							<span class="fs--12c fc-pal--grey">{{selectedRegions.length}} selected</span>
						</div>
					</div>
				</div>

				<div class="region-selector__group-body">
					<div v-if="selectedRegions && selectedRegions.length > 0" class="grid grid--b8 grid--auto">
						<div class=" grid__item"  v-if="!$store.state.app.hiddenRegions.includes(option.key)" v-for="(option, j) in selectedRegions" :key="option.key">
							<Tag class="region-selector__tag" :label="option.label" @close="removeRegion(option.key)"></Tag>
						</div>
					</div>
					<div v-else class="min-h--40 fc-pal--grey vertical-center"><em><small>No regions selected</small></em></div>
				</div>
			</div>

			<hr />

		</template>


		<div v-for="(regionGroup, i) in regions" :key="regionGroup.title" class="region-selector__group">

			<div class="region-selector__group-header clickable" @click="toggleRegionGroup(regionGroup, i)">
				<div class="grid grid--g16 grid--auto grid--nowrap grid--middle grid--spread-between">
					<div class="grid__item">
						<div class="region-selector__group-title">{{regionGroup.title}}</div>
					</div>
					<div class="grid__item">
						<span class="fonticon fs--32c fc-pal--blue" :class="{
							'fonticon--plus--circle': openRegionGroups.indexOf(regionGroup.title) === -1,
							'fonticon--minus--circle': openRegionGroups.indexOf(regionGroup.title) !== -1,
							// <attr class='fonticon--plus--circle fonticon--minus--circle' />
						}"></span>
					</div>
				</div>
			</div>

			<slide-up-down class="region-selector__group-body-wrap" :active="openRegionGroups.indexOf(regionGroup.title) !== -1">
				<div class="region-selector__group-body">
					<div class="grid grid--b0 grid--v-spread-items">
						<div class=" grid__item one-half" v-if="!$store.state.app.hiddenRegions.includes(option.value)" v-for="(option, j) in regionGroup.options" :key="option.value">
							<div class="region-selector__group-item">
								<CheckboxField v-if="isMultiSelect" :options="[option]" :value="value" @input="$emit('input', $event)"></CheckboxField>
								<RadioField v-else :options="[option]" :value="value" @input="$emit('input', $event)"></RadioField>
							</div>
						</div>
					</div>
				</div>
			</slide-up-down>

			<hr />

		</div>

		<div class="region-selector__footer">
			<div class="grid grid--g16 grid--auto grid--nowrap grid--middle grid--spread-between">
				<div class="grid__item">
					<span class="link link--action" @click="reset">Reset</span>
				</div>
				<div class="grid__item">
					<slot name="footerAction"></slot>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep, values } from 'lodash'

import Tag from '../atoms/Tag'
import RadioField from '../atoms/RadioField'
import CheckboxField from '../atoms/CheckboxField'

export default {
	name: 'RegionSelector',
	components: {
		Tag,
		RadioField,
		CheckboxField,
	},
	data () {
		return {
			initialValue: null,
			openRegionGroups: [],
		}
	},
	props: {
		value: [Array, String],
		isMultiSelect: false,
		hasUserRegions: false,
		hasSelectedSummary: false,
	},
	computed: {
		...mapGetters({
			'regions': 'app/regions',
			'flattenRegions': 'app/flattenRegions',
		}),
		selectedRegions: function()
		{
			return values(this.flattenRegions(this.value));
		},
	},
	created: function()
	{
		this.initialValue = cloneDeep(this.value);
	},
	mounted: function()
	{
	},
	methods: {
		toggleRegionGroup: function(group, i)
		{
			var index = this.openRegionGroups.indexOf(group.title);
			if(index == -1)
			{
				// this.openRegionGroups.push(group.title);
				this.openRegionGroups = [group.title];
			}
			else
			{
				this.openRegionGroups.splice(index, 1);
			}
		},
		removeRegion: function(regionKey)
		{
			var regions = cloneDeep(this.value);
			var index = regions.indexOf(regionKey);
			if(index !== -1)
			{
				regions.splice(index, 1);
			}
			this.$emit('input', regions);
		},
		reset: function()
		{
			this.$emit('input', cloneDeep(this.initialValue));
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".region-selector";
	#{$c}
	{
		width: 100vw;
		@include extend(bgc-pal--white);
		padding: rem(32);

		@include media(not-mob)
		{
			max-width: 472px;
		}

		&__group
		{
			&-header
			{
				padding: rem(15) rem(8);
				user-select: none;

				#{$c}__group:first-child &
				{
					padding-top: 0;
				}
			}

			&-title
			{
				@include extend(h5);
			}

			&-body
			{
				padding-left: rem(8);
				padding-right: rem(8);
				padding-bottom: rem(24);
			}

			&-item
			{
				min-height: rem(40);
				padding: rem(10);
				border: 1px solid #CCC;
				margin-bottom: -1px;
				margin-right: -1px;
				height: calc(100% + 1px);
			}
		}

		&__footer
		{
			padding-top: rem(24);
		}

		hr
		{
			background-color: palette(lighter-grey);
		}

		.#{$field-class}--checkbox,
		.#{$field-class}--radio
		{
			line-height: 1;

			.#{$field-class}
			{
				&__sub-label
				{
					text-indent: calc( -1em * (12 + 18) / #{var(field-font-size)} );
					padding-left: calc( 1em * (12 + 18) / #{var(field-font-size)} );

					&:before
					{
						width: rem(18);
						height: rem(18);
						font-size: rem(8);
						border-radius: 50%;
						border-width: 1px;
						font-family: $fonticon-font-family;
						margin-right: calc( 1em * 12 / 8 );
					}
				}

				&__element:checked + .#{$field-class}__sub-label
				{
					&:before
					{
						content: $fonticon--tick--bold--char;
						border-width: 2px;
						border-color: currentColor;
						color: palette('blue');
					}

					> *
					{
						color: palette('blue');
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/atoms/RegionSelector.vue